/**
 * Canonical names of the WABA template variables the backend fills in on its
 * own, mirroring the `predefined_variables` catalog in whatsapp-business-service
 * (each row maps to a column on `leads-service.leads`):
 *
 *   nombre_del_lead    -> leads.name
 *   medio              -> leads.handle
 *   correo_electronico -> leads.email
 *   empresa            -> leads.company
 *
 * `correo_electrónico` (accented) is a legacy spelling that is still the more
 * common one in production templates, so both forms have to resolve.
 *
 * Callers must treat any parameter named here as *automatic*: the value the UI
 * collects for it is discarded, because the send path substitutes the real
 * per-lead value at delivery time. Asking the user to type one is a false gate.
 *
 * This lives in one place because it used to live in two: the campaign modal
 * kept its own copy that spelled the email variable `correo`, a name no
 * template has ever used, so every campaign built on a template with an email
 * variable was blocked behind "Debes completar las variables manuales"
 * (46 approved templates across 21 workspaces at the time of the fix).
 */
export const PREDEFINED_TEMPLATE_VARIABLES: readonly string[] = [
  'nombre_del_lead',
  'medio',
  'correo_electronico',
  'correo_electrónico',
  'empresa',
];

const PREDEFINED_TEMPLATE_VARIABLES_SET: ReadonlySet<string> = new Set(
  PREDEFINED_TEMPLATE_VARIABLES,
);

/** True when the backend fills this parameter in without user input. */
export function isPredefinedTemplateVariable(paramName: string): boolean {
  return PREDEFINED_TEMPLATE_VARIABLES_SET.has(paramName);
}
